<template>
  <span />
</template>

<script>
import XlsxMixin from "@/mixins/XlsxMixin.js";
import Catalog from "../TransactionItemCatalog.js";
import Info from "../TransactionInfo.js";

export default {
  mixins: [XlsxMixin],
  props: {
    items: Array
  },
  methods: {
    exportExcel() {
      this.createBook();
      this.createSheet();

      this.addList();
      this.download(Info.Export.List.Excel.FileName);
    },

    addList() {
      // label
      this.addSequenceHeader();
      this.addColumnHeader(Catalog.Date);
      this.addColumnHeader(Catalog.Name);
      this.addColumnHeader(Catalog.DispatchName);
      this.addColumnHeader(Catalog.WarehouseName);
      this.addColumnHeader(Catalog.Changes);
      this.addColumnHeader(Catalog.QuantityAfter);


      // value
      for (const row of this.items) {
        this.addRow();

        this.addSequenceCell();
        this.addCellValue("Date", row, Catalog);
        this.addCellValue("Name", row, Catalog);
        this.addCellValue("DispatchName", row, Catalog);
        this.addCellValue("WarehouseName", row, Catalog);
        this.addCellValue("Changes", row, Catalog);
        this.addCellValue("QuantityAfter", row, Catalog);
      }

      this.addSheet(Info.Export.List.Excel.SheetName.List);
    }
  }
}
</script>